import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5fb5359e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-ui-dialog-title",
  style: {"padding-top":"27px"}
}
const _hoisted_2 = { class: "cm-ui-mr20 cm-ui-ml20 drawer-body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "task-content el-card"
}
const _hoisted_5 = {
  key: 0,
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "summary"
}
const _hoisted_10 = { class: "distribution-status" }
const _hoisted_11 = { class: "computer_name" }
const _hoisted_12 = { class: "cm-ui-txt-cte cm-ui-pd20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Keywords = _resolveComponent("Keywords")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    size: "800px",
    "model-value": _ctx.props.modelValue,
    direction: "rtl",
    "before-close": () => _ctx.handleEvent('close'),
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('noticeManage.taskTitleWithName', { name: _ctx.type })), 1),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.props.row.detail !== '--')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.$t('noticeManage.taskContent')), 1))
          : _createCommentVNode("", true),
        (_ctx.props.row.detail !== '--')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ([42,40].includes(_ctx.props.row.task_type) && _ctx.parseArrayOnly(_ctx.props.row.detail))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.fileMd5Label')) + " ", 1),
                    (_ctx.parseArrayOnly(_ctx.props.row.detail).length)
                      ? (_openBlock(), _createBlock(_component_Keywords, {
                          key: 0,
                          placement: "bottom",
                          "max-count": 2,
                          keywords: _ctx.parseArrayOnly(_ctx.props.row.detail)
                        }, null, 8, ["keywords"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))
                  ]))
                : ([41,43,44,45].includes(_ctx.props.row.task_type) &&  _ctx.parseArrayOnly(_ctx.props.row.detail) )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.filePathLabel')) + " ", 1),
                      (_ctx.parseArrayOnly(_ctx.props.row.detail).length)
                        ? (_openBlock(), _createBlock(_component_Keywords, {
                            key: 0,
                            placement: "bottom",
                            "max-count": 2,
                            keywords: _ctx.parseArrayOnly(_ctx.props.row.detail)
                          }, null, 8, ["keywords"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, "--"))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.props.row.detail || "--"), 1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('noticeManage.distributionStatus')), 1),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_ContentAdaptLayout, null, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  class: "pagination",
                  "page-sizes": [10, 20, 30, 50, 100],
                  "page-size": _ctx.query.limit,
                  "current-page": _ctx.query.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.state.total,
                  onSizeChange: _ctx.getTableData,
                  onCurrentChange: _ctx.getListByPage
                }, null, 8, ["page-size", "current-page", "total", "onSizeChange", "onCurrentChange"])
              ])
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
                class: "tabs",
                modelValue: _ctx.state.tabActive,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tabActive) = $event)),
                onTabClick: _ctx.tabClick
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (panel) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      class: "tab-pane",
                      label: panel.label,
                      name: panel.name,
                      key: panel.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table, {
                          "empty-text": _ctx.$t('common.noData'),
                          height: "100%",
                          data: _ctx.state.tableData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              label: _ctx.$t('listColumns.computerName'),
                              prop: "computer_name",
                              width: "200"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(scope.row.login_status === 1? 'online': 'offline')
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(scope.row.computer_name), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _ctx.$t('listColumns.userMark'),
                              prop: "user_mark"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _ctx.$t('listColumns.groupName'),
                              prop: "group_name"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _ctx.$t('noticeManage.ipAddress'),
                              prop: "ip"
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_IPColumn, {
                                  cip: scope.row.client_ip,
                                  sip: scope.row.system_ip
                                }, null, 8, ["cip", "sip"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["empty-text", "data"])
                      ]),
                      _: 2
                    }, 1032, ["label", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onTabClick"])), [
                [_directive_loading, _ctx.state.status]
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}